import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn } from "./ui";

export const BouquetsDialog = ({ c, onClose, onDone }) => {
  const [list, setList] = useState([]);
  const [sel, setSel] = useState(c.bouquets || []);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/bouquets").then((r) => setList(r.data)); }, []);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/clients/${c.id}/bouquets`, { bouquets: sel });
      toast.success("Bouquets atualizados no SYSLOG");
      onDone(data.client);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha ao salvar bouquets"); }
    setBusy(false);
  };
  return (
    <Modal testid="bouquets-dialog" title="Bouquets" onClose={onClose}>
      <p className="mb-3 text-xs text-slate-400">Os mesmos do Sigma/SYSLOG. Sem nenhum marcado, vale o padrão do plano.</p>
      <div className="space-y-2">
        {list.map((b) => (
          <label key={b.id} data-testid={`bouquet-${b.id}`} className="flex cursor-pointer items-center gap-3 rounded-lg border border-[#202D45] bg-[#111827] px-3 py-2 text-sm text-slate-200 hover:border-sky-500/50">
            <input type="checkbox" checked={sel.includes(b.id)} onChange={() => toggle(b.id)} className="h-4 w-4 accent-sky-500" />
            <span className="font-mono text-xs text-slate-500">[{b.id}]</span> {b.name}
          </label>
        ))}
      </div>
      <div data-testid="bouquets-summary" className="mt-3 text-xs text-slate-400">
        {sel.length ? `${sel.length} selecionado(s)` : "Padrão do plano"}
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <Btn tone="ghost" onClick={onClose}>Cancelar</Btn>
        <Btn data-testid="bouquets-save" disabled={busy} onClick={save}>{busy ? "Salvando no SYSLOG..." : "Salvar no SYSLOG"}</Btn>
      </div>
    </Modal>
  );
};
